<template>
	<!-- 业绩路演 -->
	<div class="quarter-card" v-if="quarterDetails.roadshowId" @click="itemHandler">
		<h4>
			{{ $t('enterprise.earnings-calls') }}
		</h4>
		<div class="roadshow-box">
			<div>
				<p class="roadshow-title">{{ quarterDetails.roadshowTitle }}</p>
				<p class="roadshow-info">
					<span class="roadshow-status" :class="[`roadshow-status-${quarterDetails.roadshowStatus}`]">{{
						getRoadshowStatus(quarterDetails.roadshowStatus)
					}}</span>
					<span class="roadshow-time">{{
						moment(quarterDetails.roadshowStartTime).format('YYYY-MM-DD hh:mm')
					}}</span>
				</p>
			</div>
			<img class="roadshow-img" :src="quarterDetails.roadshowCover" alt="" />
		</div>
	</div>
</template>

<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import moment from 'moment';
import { useQuarterlyCommon } from '@rebuild/materials/shared/quarterly_performance/useQuarterlyCommon';

const props = defineProps({
	quarterDetails: {
		type: Object,
		required: true
	}
});

const { getRoadshowStatus } = useQuarterlyCommon();

const { viewModule } = useModuleNavigation();
const itemHandler = () => {
	viewModule('quarterly_performance_roadshow', props.quarterDetails);
};
</script>

<style lang="less" scoped>
.quarter-card {
	margin-bottom: 12px;
	padding: 16px;
	border-radius: 6px;
	background: #fff;
	h4 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: var(--t-emphasis-color, #1d2129);

		font-size: 16px;
		font-weight: 500;
		line-height: 24px; /* 150% */
	}

	.roadshow-box {
		padding-top: 14px;
		display: flex;
		align-items: flex-start;
		gap: 8px;
		.roadshow-title {
			color: var(---__black_text, #12121a);
			font-size: 15px;
			font-weight: 500;
			line-height: 24px; /* 160% */
		}
		.roadshow-info {
			display: flex;
			align-items: center;
			padding-top: 12px;
			gap: 8px;
			.roadshow-status {
				display: inline-flex;
				height: 18px;
				padding: 0 4px;
				border-radius: 1px;
				color: #fff;

				font-size: 10px;

				font-weight: 400;
				line-height: 18px; /* 140% */

				&-1,
				&-2,
				&-5 {
					color: #f07146;
					background: #fdf1ec;
				}
				&-3,
				&-12,
				&-13,
				&-14 {
					color: #f44646;
					background: #ffebea;
				}
				&-4,
				&-8 {
					color: #30bf54;
					background: var(
						---,
						linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%),
						#36d95f
					);
				}
				&-6 {
					color: #3964e5;
					background: #ebeffc;
				}
				&-7,
				&-9,
				&-10,
				&-11 {
					color: #4e5969;
					background: #e8ebf1;
				}
			}
		}
		.roadshow-img {
			width: 100px;
			height: 75px;
			border-radius: 4px;
			object-fit: cover;
		}
	}
}
</style>
